import {isNilOrEmpty} from 'ramda-adjunct';

import {getCellClassName, getNumericCellClassName} from '../../utils/getCellClassName';

type EmptyCellValueProps = {
  /** Placeholder resolved from the emptyCellValueMode setting — '' / undefined
   * renders nothing, '–' (en dash) renders a dash. */
  emptyCellValue: string | undefined;
  isWrap: boolean;
  /** Numeric columns right-align the placeholder to match their values. */
  isNumeric?: boolean;
};

/**
 * Shared empty-cell output for renderers whose empty branch renders no value.
 * Returns null when the placeholder is empty (NOTHING mode — the historical
 * behavior), a plain text placeholder otherwise (DASH mode). Deliberately
 * carries no tooltip wrapper so empty cells stay hover-inert.
 */
export function EmptyCellValue(props: EmptyCellValueProps) {
  if (isNilOrEmpty(props.emptyCellValue)) {
    return null;
  }

  const className = props.isNumeric
    ? getNumericCellClassName(props.isWrap)
    : getCellClassName(props.isWrap);

  return <div className={className}>{props.emptyCellValue}</div>;
}
